import type { NavItem } from '@/lib/contentful/api/getWebsiteConfig';

type CtaButton = { text: string; url: string; isNewTab: boolean } | null;

type Props = {
  navItems: NavItem[];
  ctaButton: CtaButton;
  scrolled: boolean;
  isActive: (item: NavItem) => boolean;
  handleClick: (e: React.MouseEvent<HTMLAnchorElement>, item: NavItem) => void;
};

export default function DesktopNav({
  navItems,
  ctaButton,
  scrolled,
  isActive,
  handleClick,
}: Props) {
  return (
    <>
      <ul className="hidden tablet:flex gap-9 list-none m-0 p-0">
        {navItems.map((item) => (
          <li key={item.id}>
            <a
              href={item.href}
              onClick={(e) => handleClick(e, item)}
              aria-current={isActive(item) ? 'page' : undefined}
              className={[
                'font-sans text-[0.78rem] tracking-[0.1em] uppercase no-underline transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
                isActive(item)
                  ? 'text-primary'
                  : 'text-[var(--text-mid)] hover:text-primary',
              ].join(' ')}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>

      {ctaButton && (
        <a
          href={ctaButton.url}
          {...(ctaButton.isNewTab && {
            target: '_blank',
            rel: 'noopener noreferrer',
          })}
          className={`hidden tablet:inline-block bg-primary text-white font-sans text-[0.75rem] font-bold tracking-[0.1em] uppercase no-underline transition-all hover:bg-[var(--color-primary-dark)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${scrolled ? 'px-[1.3rem] py-[0.55rem]' : 'px-6 py-[0.65rem]'}`}
        >
          {ctaButton.text}
        </a>
      )}
    </>
  );
}
